export default __webpack_public_path__ + "static/media/orders24.1a350b82.svg";